// extracted by mini-css-extract-plugin
export default {"tooltip":"Tooltip_tooltip__7nBuD","icon":"Tooltip_icon__JNSN-","content":"Tooltip_content__vpUuw"};